if (!customElements.get('read-more-text')) {
  customElements.define(
    'read-more-text',
    class ReadMoreText extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-read-more-content]');
        this.toggle = this.querySelector('[data-read-more-toggle]');
        if (!this.content || !this.toggle) return;

        this.moreText = this.toggle.dataset.moreText || 'Läs mer';
        this.lessText = this.toggle.dataset.lessText || 'Läs mindre';

        this.toggle.addEventListener('click', this.onToggle.bind(this));
        this._onResize = this.check.bind(this);
        window.addEventListener('resize', this._onResize);

        // Wait for fonts/layout before measuring overflow
        requestAnimationFrame(() => this.check());
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.check());
        }
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
      }

      check() {
        if (this.classList.contains('is-expanded')) return;
        const overflowing =
          this.content.scrollHeight - this.content.clientHeight > 2;
        this.toggle.hidden = !overflowing;
      }

      onToggle() {
        const expanded = this.classList.toggle('is-expanded');
        this.toggle.textContent = expanded ? this.lessText : this.moreText;
        this.toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }
  );
}
